import * as React from "react";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Box from "@mui/material/Box";
import OrdersMaterialTable from "./MaterialTables/OrdersMaterialTable";
import SubmittedQuotesMaterialTable from "./MaterialTables/SubmittedQuotesMaterialTable";
import QuoteResultsMaterialTable from "./MaterialTables/QuoteResultsMaterialTable";
import CustomTabPanel from "../components/CustomTabPanel";

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

export default function ForwarderQuoteTabs() {
  const [value, setValue] = React.useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <Box sx={{ width: "100%" }}>
      <Box className="pl-4" sx={{ borderBottom: 0.5, borderColor: "divider" }}>
        <Tabs
          className="mt-[-0.3rem]"
          value={value}
          onChange={handleChange}
          textColor="green"
          TabIndicatorProps={{
            style: { backgroundColor: "green" },
          }}
        >
          <Tab
              className={`mr-4 !outline-none !font-bold !capitalize pt-3 ${value === 0 ? 'tab-active' : 'tab-inactive'}`}
              label="Orders"
            {...a11yProps(0)}
          />
          <Tab
              className={`mr-4 !outline-none !font-bold !capitalize pt-3 ${value === 1 ? 'tab-active' : 'tab-inactive'}`}
              label="Submitted Quotes"
            {...a11yProps(1)}
          />
          <Tab
              className={`mr-4 !outline-none !font-bold !capitalize pt-3 ${value === 2 ? 'tab-active' : 'tab-inactive'}`}
              label="Quote Results"
            {...a11yProps(2)}
          />
        </Tabs>
      </Box>
      <CustomTabPanel value={value} index={0}>
        <OrdersMaterialTable tableName="ForwarderQuoteOrders"/>
      </CustomTabPanel>
      <CustomTabPanel value={value} index={1}>
        <SubmittedQuotesMaterialTable tableName="ForwarderSubmittedQuoteOrders"/>
      </CustomTabPanel>
      <CustomTabPanel value={value} index={2}>
        <QuoteResultsMaterialTable tableName="ForwarderQuoteResults"/>
      </CustomTabPanel>
    </Box>
  );
}
